import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as bookActions from '../../actions/bookActions';
import * as classroomActions from '../../actions/classroom/classroomActions';
import {
  ROLE,
  ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS,
  TABS_CONSTANTS,
  TABS_CONSTANTS_CONFIG,
  TABS_CONSTANTS_TRANSLATIONS
} from '../../const';
import SadMonster from '../common/EmptyListPlaceholder/SadMonster';
import MyContent from '../book/MyContent/index';
import ClassroomBasicAnalytics from '../ClassRoomBasicAnalytics';
import * as routeUtils from '../../utils/routeUtils';
import SwipeableTabsContainer from '../common/SwipeableTabsContainer';
import AssignmentsContainer from '../assignments/AssignmentsContainer';
import DiscussionsWrapper from '../discussions/DiscussionsList/DiscussionsWrapper';
import Gradebook from '../Gradebook/Gradebook';
import LibraryContainer from '../library/LibraryContainer';
import ParticipantsWrapper from './students/ParticipantsWrapper';
import StudentAnnotations from './annotations/StudentAnnotations';

class Classroom extends React.Component {
  constructor(props, context) {
    super(props, context);
    classroomActions.setClassroomInfo();
    bookActions.setBooksData();
  }

  static propTypes = {
    books: PropTypes.array,
    routeParams: PropTypes.any,
    classroomActions: PropTypes.any,
    bookActions: PropTypes.any,
    layoutSettings: PropTypes.any,
    isAppOnline: PropTypes.any,
    classroomRole: PropTypes.string,
    role: PropTypes.string,
    location: PropTypes.any,
    tab: PropTypes.string,
    jailed: PropTypes.bool,
    classroomTabs: PropTypes.array
  };

  componentDidMount() {
    const { routeParams, bookActions, classroomRole } = this.props;
    let classroomId = routeParams.idClassroom;
    
    // Solo hacer petición de libros si hay información de la clase
    if (classroomRole && classroomId) {
      bookActions.getBooksData(classroomId);
    }
  }

  getViewByTabConst(tabConst) {
    switch (tabConst) {
      case TABS_CONSTANTS.MY_CONTENTS:
        return <MyContent key="mycontent" />;
      case TABS_CONSTANTS.CLASSROOM_WORKSPACE_LIBRARY:
        return <MyContent key="mycontent" />;
      case TABS_CONSTANTS.CLASSROOM_WORKSPACE_LIBRARY_STUDENT:
        return <MyContent key="mycontent" />;
      case TABS_CONSTANTS.ANALYTICS:
        return <ClassroomBasicAnalytics key="classroomBasicAnalytics" />;
      case TABS_CONSTANTS.ASSIGNMENTS:
        return <AssignmentsContainer key="assignments" />;
      case TABS_CONSTANTS.CLASSROOM_STUDENTS:
        return <ParticipantsWrapper key="students" />;
      case TABS_CONSTANTS.DISCUSSIONS:
        return <DiscussionsWrapper key="discussions" />;
      case TABS_CONSTANTS.GRADEBOOK:
        return <Gradebook key="gradebook" />;
      case TABS_CONSTANTS.CLASSROOM_LIBRARY:
        return <LibraryContainer key="library" />;
      case TABS_CONSTANTS.STUDENT_ANNOTATIONS:
        return <StudentAnnotations key="studentAnnotations" />;
      default:
        return <SadMonster msgKey="common.notImplemented" key="sad" />;
    }
  }

  getVisibleTabs() {
    const { classroomTabs, classroomRole } = this.props;
    if (!classroomTabs) return [];

    const isStudent = classroomRole === ROLE.STUDENT;
    return classroomTabs.filter(tab => {
      const tabConfig = TABS_CONSTANTS_CONFIG[tab];
      return isStudent ? !tabConfig.studentDisabled : !tabConfig.instructorDisabled;
    });
  }

  renderSwipeableViews() {
    return this.getVisibleTabs().map(tabConst => {
      return this.getViewByTabConst(tabConst);
    });
  }

  getTabsConstants() {
    const { isAppOnline } = this.props;
    const tabObject = {};
    let disabledTab = false;

    this.getVisibleTabs().forEach(tab => {
      if (!isAppOnline) {
        disabledTab = TABS_CONSTANTS_CONFIG[tab].offlineDisabled;
      }

      tabObject[tab] = {
        label: TABS_CONSTANTS_TRANSLATIONS[tab],
        key: tab,
        disabledTab,
        icon: ROUTES_CONSTANTS_TRANSLATIONS_AND_ICONS[tab].icon
      };
    });
    return tabObject;
  }

  getSelectedTabIndex() {
    const { jailed } = this.props;
    const visibleTabs = this.getVisibleTabs();
    if (!visibleTabs.length) return 0;
    const jailedTab = routeUtils.getParameterByName('jailedTab', this.props.location.search);
    let activeTabIndex = 0;
    if (jailed && jailedTab) {
      const jailedTabIndex = visibleTabs.indexOf(jailedTab);
      if (jailedTabIndex >= 0) {
        activeTabIndex = jailedTabIndex;
      }
    } else {
      const { tab } = this.props;
      activeTabIndex = visibleTabs.indexOf(tab);
      if (activeTabIndex < 0) {
        activeTabIndex = 0;
      }
    }
    return activeTabIndex;
  }

  render() {
    return (
      <SwipeableTabsContainer
        selectedTabIndex={this.getSelectedTabIndex()}
        setActiveTab={classroomActions.setActiveTab}
        tabsConstants={this.getTabsConstants()}
        views={this.renderSwipeableViews()}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    classroomRole: state.classrooms.selectedClassroom.classroom.role,
    role: state.account.user.role,
    books: state.book.books,
    layoutSettings: state.theme.layoutSettings,
    isAppOnline: state.connection.status.online,
    jailed: state.account.jailed,
    classroomTabs: state.account.configuration.classroomTabs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Classroom);
